import { render, staticRenderFns } from "./CategoriesGroupCreate.vue?vue&type=template&id=0a2e50ff&scoped=true&"
import script from "./CategoriesGroupCreate.vue?vue&type=script&lang=js&"
export * from "./CategoriesGroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesGroupCreate.vue?vue&type=style&index=0&id=0a2e50ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e50ff",
  null
  
)

export default component.exports